<template>
  <div class="contest-entry-item">
    <div class="name-container">
      <div class="name">{{ name }}</div>
      <template v-if="required !== undefined">
        <div v-if="required" class="batch required">{{ $t("common.required") }}</div>
        <div v-else class="batch optional">{{ $t("common.optional") }}</div>
      </template>
    </div>
    <div v-if="description" class="description">{{ description }}</div>
    <slot />
    <div v-if="error" class="error-message">{{ error }}</div>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";

export default Vue.extend<Data, Methods, Computed, Props>({
  props: {
    name: {
      type: String as PropType<string>,
      required: true,
    },
    required: {
      type: Boolean as PropType<boolean>,
      required: false,
      default: undefined,
    },
    description: {
      type: String as PropType<string>,
      required: false,
    },
    error: {
      type: String as PropType<string>,
      required: false,
    },
  },
});

interface Props {
  name: string;
  required?: boolean;
  description?: string;
  error?: string;
}

interface Data {}

interface Computed {}

interface Methods {}
</script>

<style lang="scss" scoped>
.contest-entry-item {
  display: flex;
  flex-direction: column;
  color: var(--color-text-normal);

  .name-container {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    .name {
      font-weight: var(--font-weight-bold);
      font-size: 1.2em;
      color: var(--color-text-normal);
    }

    .batch {
      font-weight: var(--font-weight-bold);
      font-size: 0.8em;
      color: var(--color-text-on-fixed-bg);
      border-radius: 1em;
      box-sizing: border-box;
      padding: 3px 8px;
      margin-left: 1em;

      &.required {
        background-color: #f77575;
      }

      &.optional {
        background-color: #9e9e9e;
      }
    }
  }

  .description {
    color: var(--color-text-low);
    margin-bottom: 10px;
  }

  .error-message {
    color: var(--color-warning);
    font-weight: var(--font-weight-bold);
    margin-top: 10px;
  }
}
</style>
